import { supabase } from '../integrations/supabase/client';

export interface DadosIrradiacao {
  cidade: string;
  estado: string;
  janeiro: number;
  fevereiro: number;
  marco: number;
  abril: number;
  maio: number;
  junho: number;
  julho: number;
  agosto: number;
  setembro: number;
  outubro: number;
  novembro: number;
  dezembro: number;
  media: number;
}

export const irradiacaoService = {
  // Buscar dados de irradiação por cidade e estado
  async getByCidadeEstado(cidade: string, estado: string): Promise<DadosIrradiacao | null> {
    try {
      const { data, error } = await supabase
        .from('irradiacao')
        .select('*')
        .eq('Cidade', cidade)
        .eq('Estado', estado)
        .single();

      if (error) {
        console.error('Erro ao buscar irradiação:', error);
        return null;
      }

      if (!data) {
        return null;
      }

      // Converter dados de string para número e normalizar nomes das colunas
      return {
        cidade: data.Cidade || '',
        estado: data.Estado || '',
        janeiro: parseFloat(data.Jan?.replace(',', '.') || '0'),
        fevereiro: parseFloat(data.Fev?.replace(',', '.') || '0'),
        marco: parseFloat(data.Mar?.replace(',', '.') || '0'),
        abril: parseFloat(data.Abr?.replace(',', '.') || '0'),
        maio: parseFloat(data.Mai?.replace(',', '.') || '0'),
        junho: parseFloat(data.Jun?.replace(',', '.') || '0'),
        julho: parseFloat(data.Jul?.replace(',', '.') || '0'),
        agosto: parseFloat(data.Ago?.replace(',', '.') || '0'),
        setembro: parseFloat(data.Set?.replace(',', '.') || '0'),
        outubro: parseFloat(data.Out?.replace(',', '.') || '0'),
        novembro: parseFloat(data.Nov?.replace(',', '.') || '0'),
        dezembro: parseFloat(data.Dez?.replace(',', '.') || '0'),
        media: parseFloat(data.Média?.replace(',', '.') || '0')
      };
    } catch (error) {
      console.error('Erro ao buscar irradiação:', error);
      return null;
    }
  },

  // Buscar dados de irradiação por cidade (busca mais flexível)
  async getByCidade(cidade: string): Promise<DadosIrradiacao | null> {
    try {
      const { data, error } = await supabase
        .from('irradiacao')
        .select('*')
        .ilike('Cidade', `%${cidade}%`)
        .limit(1)
        .single();

      if (error) {
        console.error('Erro ao buscar irradiação por cidade:', error);
        return null;
      }

      if (!data) {
        return null;
      }

      // Converter dados de string para número e normalizar nomes das colunas
      return {
        cidade: data.Cidade || '',
        estado: data.Estado || '',
        janeiro: parseFloat(data.Jan?.replace(',', '.') || '0'),
        fevereiro: parseFloat(data.Fev?.replace(',', '.') || '0'),
        marco: parseFloat(data.Mar?.replace(',', '.') || '0'),
        abril: parseFloat(data.Abr?.replace(',', '.') || '0'),
        maio: parseFloat(data.Mai?.replace(',', '.') || '0'),
        junho: parseFloat(data.Jun?.replace(',', '.') || '0'),
        julho: parseFloat(data.Jul?.replace(',', '.') || '0'),
        agosto: parseFloat(data.Ago?.replace(',', '.') || '0'),
        setembro: parseFloat(data.Set?.replace(',', '.') || '0'),
        outubro: parseFloat(data.Out?.replace(',', '.') || '0'),
        novembro: parseFloat(data.Nov?.replace(',', '.') || '0'),
        dezembro: parseFloat(data.Dez?.replace(',', '.') || '0'),
        media: parseFloat(data.Média?.replace(',', '.') || '0')
      };
    } catch (error) {
      console.error('Erro ao buscar irradiação por cidade:', error);
      return null;
    }
  },

  // Converter dados para formato de gráfico
  formatarParaGrafico(dados: DadosIrradiacao) {
    return [
      { mes: 'Jan', irradiacao: dados.janeiro },
      { mes: 'Fev', irradiacao: dados.fevereiro },
      { mes: 'Mar', irradiacao: dados.marco },
      { mes: 'Abr', irradiacao: dados.abril },
      { mes: 'Mai', irradiacao: dados.maio },
      { mes: 'Jun', irradiacao: dados.junho },
      { mes: 'Jul', irradiacao: dados.julho },
      { mes: 'Ago', irradiacao: dados.agosto },
      { mes: 'Set', irradiacao: dados.setembro },
      { mes: 'Out', irradiacao: dados.outubro },
      { mes: 'Nov', irradiacao: dados.novembro },
      { mes: 'Dez', irradiacao: dados.dezembro }
    ];
  }
};

